/**
 * Workspace Constants
 *
 * Shared constants for workspace feature components.
 */

/** Delay in ms to distinguish single click from double click */
export const CLICK_DELAY_MS = 250;
